import { useMutation } from '@tanstack/react-query';

import saveGamificationProgress from '@/api/gamificationProgress/saveGamificationProgress.endpoint';
import saveRetryPolicy from '@/v2/conf/queryClient/hooks/retry/saveRetryPolicy';
import { GAMIFICATION_SAVE_SCOPE } from '@/v2/domains/Student/Gamification/constants/gamificationSaveConstants';

type SaveGamificationProgressVariables = {
  activityId: number | string;
  data: Record<string, unknown>;
};

export default function useSaveGamificationProgressMutation() {
  return useMutation({
    mutationFn: ({ activityId, data }: SaveGamificationProgressVariables) =>
      saveGamificationProgress(activityId, data),
    retry: saveRetryPolicy,
    scope: { id: GAMIFICATION_SAVE_SCOPE },
    meta: {
      notification: {
        error: () => false,
      },
    },
  });
}
